import { defineMessages } from 'react-intl';

export default defineMessages({
  stable: 'Stable',
  variable: 'Variable',
  yes: 'Yes',
  no: 'No',
});
